var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import axios from "../../node_modules/axios/lib/axios.mjs";
class PublicClient {
  constructor(config = {}, axiosInstance = axios) {
    __publicField(this, "instance");
    this.instance = axiosInstance.create(config);
  }
  async post({ endpoint, params, body, headers, responseType }) {
    return this.instance.post(
      endpoint,
      body,
      {
        params,
        headers,
        responseType
      }
    ).catch((e) => {
      console.error(e);
      throw e;
    });
  }
  async put({ endpoint, params, body, headers }) {
    return this.instance.put(
      endpoint,
      body,
      {
        params,
        headers
      }
    ).catch((e) => {
      console.error(e);
      throw e;
    });
  }
  async patch({ endpoint, params, body, headers }) {
    return this.instance.patch(
      endpoint,
      body,
      {
        params,
        headers
      }
    ).catch((e) => {
      console.error(e);
      throw e;
    });
  }
  async get({ endpoint, params, headers, responseType, paramsSerializer }) {
    return this.instance.get(endpoint, { params, headers, responseType, paramsSerializer }).catch((e) => {
      console.error(e);
      throw e;
    });
  }
  async delete({ endpoint, params, body, headers }) {
    return this.instance.delete(
      endpoint,
      {
        data: body,
        params,
        headers
      }
    ).catch((e) => {
      console.error(e);
      throw e;
    });
  }
}
export {
  PublicClient as default
};
